import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ChevronRight, Home } from "lucide-react";
import { Container } from "./ui-kit";
import { SITE_URL } from "./Seo";

const Breadcrumbs = ({ items = [] }) => {
  const all = [{ label: "Anasayfa", to: "/" }, ...items];
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: all.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `${SITE_URL}${it.to || ""}`,
    })),
  };

  return (
    <div className="border-b border-line bg-canvas" data-testid="breadcrumbs">
      <Container className="py-3.5">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[12px] flex-wrap">
          {all.map((it, i) => {
            const last = i === all.length - 1;
            return (
              <span key={`${it.to}-${it.label}`} className="flex items-center gap-2">
                {i > 0 && <ChevronRight size={13} className="text-line" />}
                {last ? (
                  <span className="text-ink font-medium" aria-current="page" data-testid="breadcrumb-current">
                    {it.label}
                  </span>
                ) : (
                  <Link
                    to={it.to}
                    className="text-mute hover:text-brand transition-colors flex items-center gap-1.5"
                    data-testid={`breadcrumb-${it.to === "/" ? "home" : it.to.slice(1)}`}
                  >
                    {i === 0 && <Home size={12} />}
                    {it.label}
                  </Link>
                )}
              </span>
            );
          })}
        </nav>
      </Container>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
    </div>
  );
};

export default Breadcrumbs;
